import { ApplicationConfig, provideZoneChangeDetection, APP_INITIALIZER } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { routes } from './app.routes';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
 
import { PreInitService, preInitServiceFactory } from './config/config-service';
import { MessageService } from 'primeng/api';
import { ScrollService } from './service/scroll.service';
 
export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
 
    providePrimeNG({
       theme: {
        preset: Aura,
        options: {
            darkModeSelector: false || 'none'
        }
    }
    }),
 
    provideHttpClient(withInterceptorsFromDi()),
 
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   multi: true,
    // },
 
    // App-specific services
    PreInitService,
    MessageService,
    ScrollService, // Add ScrollService here
    //StorageMessageService,
    {
      provide: APP_INITIALIZER,
      useFactory: preInitServiceFactory,
      multi: true,
    },
  ],
};